<template>
  <section class="copyright">
    <div class="container">
      <el-row class="py-3">
        <el-col :xs="24" :sm="18" :md="16">
          <div class="text fw-l fs-lg hidden-sm-and-down">
            {{ copyright[0] }} <br />
            {{ copyright[1] }}
          </div>
          <div class="text fw-l fs-xl text-center hidden-sm-and-up mt-2 mb-1">
            {{ copyright[0] }}
            <br />
            {{ copyright[1] }}
          </div>
        </el-col>
        <el-col class="text-right" :xs="24" :sm="6" :md="8">
          <div
            class="text-white fs-xl hidden-sm-and-down"
            style="
              opacity: 0.6;
              height: 100%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            "
          >
            浏览人次: {{ count }}
          </div>
          <div
            class="text-white fs-xl mt-2 hidden-sm-and-up"
            style="opacity: 0.6; height: 100%; text-align: center"
          >
            浏览人次: {{ count }}
          </div>
        </el-col>
      </el-row>
    </div>
  </section>
</template>

<script>
import 'element-plus/theme-chalk/display.css'
import { COPYRIGHT, NAV_LIST } from '@/config/constant.js'

export default {
  props: {
    count: Number
  },
  setup() {
    return {
      copyright: COPYRIGHT,
      navList: NAV_LIST
    }
  }
}
</script>

<style lang="scss" scoped>
.copyright {
  background: #2f3844;
  color: #fff;
}
</style>
